/**
 * Sentry (browser) — gated on REACT_APP_SENTRY_DSN. When blank, this is a
 * complete no-op. Never sends emails, tokens, or auth headers to Sentry.
 */
import * as Sentry from "@sentry/react";

let initialised = false;

export function initSentry() {
  if (initialised) return;
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return; // gated
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      // Strip PII: emails, JWT-shaped tokens, Authorization headers.
      try {
        if (event.request?.headers) {
          delete event.request.headers.Authorization;
          delete event.request.headers.authorization;
          delete event.request.headers.Cookie;
          delete event.request.headers.cookie;
        }
        if (event.user) {
          delete event.user.email;
          delete event.user.ip_address;
        }
        // Remove any breadcrumbs that look like they contain a JWT.
        if (event.breadcrumbs) {
          event.breadcrumbs = event.breadcrumbs.filter((b) => {
            const s = JSON.stringify(b || "");
            return !/eyJ[A-Za-z0-9_\-]+\.eyJ/.test(s);
          });
        }
      } catch {
        /* best-effort scrub */
      }
      return event;
    },
  });
  initialised = true;
}

export { Sentry };
